import { cn } from "tools/ui";

function ColForm(props) {
  const { colspan, children } = props;
  let _colspan = "";
  if (colspan) {
    _colspan = cn(" md:col-span-1 lg:col-span-1 xl:col-span-1", props.colspan);
  }
  return (
    <div className={cn(_colspan, "mt-1 xl:my-1 md:min-w-32 w-full relative")}>
      {children}
    </div>
  );
}

export default ColForm;
